export default "__VITE_ASSET__AIvCrzHQ__"